import echarts from 'echarts';

const fontColor = '#c0c0c0';
const fontSize = 12;
const barColor = ['#00C9FF', '#0078FF'];
const barMColor = ['#4FAEFD', '#FF7C3A', '#FED423'];
const barColorOpacity = ['rgba(0,201,255, .1)', 'rgba(0,120,255, .1)'];
const barLineBasicColor = 'rgba(0, 201, 255, 0)';
export const config = {
  fontColor,
  fontSize,
  barColor,
  barMColor,
  barColorOpacity,
  barLineBasicColor,
  tooltip: {
    //提示框组件
    trigger: 'axis',
    // formatter: '{b}<br />{a0}: {c0}',
    axisPointer: {
      type: 'shadow',
      label: {
        // backgroundColor: '#fff'
      },
    },
    textStyle: {
      color: fontColor,
      fontStyle: 'normal',
      fontFamily: '微软雅黑',
      fontSize,
    },
  },
  legend: {
    top: '2%',
    itemWidth: 13,
    itemHeight: 9,
    itemStyle: {
      borderWidth: 1,
    },
    textStyle: {
      color: '#dcdcdc',
      fontSize,
    },
  },
  grid: {
    left: 10,
    top: '30%',
    right: 10,
    bottom: 0,
    containLabel: true,
  },
  xAxis: [
    {
      type: 'category',
      axisLabel: {
        color: fontColor,
        textStyle: {
          fontSize,
        },
        interval: 0,
      },
      axisLine: {
        // show: false,
        lineStyle: {
          color: 'rgba(56, 89, 130, 0.4)',
        },
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: 'rgba(56, 89, 130, 0.4)',
        },
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
      nameTextStyle: {
        color: fontColor,
        fontSize,
        // padding: bool ? [0, 0, 0, -20] : [0, 0, -8, 0],
      },
      axisLabel: {
        formatter: '{value}',
        textStyle: {
          color: fontColor,
          fontSize,
        },
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: 'rgba(56, 89, 130, 0.4)',
        },
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: 'rgba(56, 89, 130, 0.4)',
        },
      },
    },
  ],
};
